import { styled } from "@mui/material/styles";
import ApexChart from "react-apexcharts";

export const Chart = styled(ApexChart)``;
